import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../store/actions'
import DefaultLayout from '../../layouts/default'
import Loading from '../../components/loading'

function mapStateToProps(state) {
  return { page: state.pageData };
}

const mapDispatchToProps = (dispatch) => {
  const { fetchPageById } = actions;
  return {
    fetchPageById: bindActionCreators(fetchPageById, dispatch)
  }
}

class ShopTour extends Component {
  constructor() {
    super();

    this.state = {
      pageNumber: 1
    }
  }

  componentWillMount() {
    this.fetchPage(this.props);
  }

  fetchPage(props) {
    let _props = props || this.props;

    _props.fetchPageById(735, () => {
      this.setState({
        isLoading: false
      })
    })
  }

  render() {
    const page = this.props.page

    if (this.state.isLoading || !page.id) { return <Loading /> }

    return (
      <DefaultLayout pagetitle={ this.props.pagetitle }>
        <div className="container container--grid">
          <div className="row">
            <div className="col" dangerouslySetInnerHTML={{ __html: page.content.rendered }}></div>
          </div>
        </div>
      </DefaultLayout>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps)(ShopTour);



// WEBPACK FOOTER //
// ./src/routes/shop-tour/index.js